export default __webpack_public_path__ + "static/media/tpp-annual-vaccination.1cd59f73.svg";